import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  linhaTabela: {
    fontSize: '13px',
  },
  tituloTabela: {
    fontSize: '13px',
    fontWeight: 'bold',
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  detailPanel: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  detailTitle: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: theme.palette.text.primary,
  },
  dividerTitle: {
    margin: theme.spacing(1, 0),
  },
  grupoEspelho: {
    padding: theme.spacing(1.5, 0),
  },
  dadoEspelho: {
    fontSize: '12px',
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
  },
  valorEspelho: {
    fontSize: '13px',
    color: theme.palette.text.primary,
  },
  realizada: {
    color: theme.palette.success.main,
    fontWeight: 'bold',
    fontSize: '12px',
  },
  naoRealizada: {
    color: theme.palette.text.secondary,
    fontSize: '12px',
  },
  
  // Mobile Card Styles
  cardMobile: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    borderRadius: '12px',
    boxShadow: 'none',
    transition: 'box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
      borderColor: theme.palette.primary.light,
    },
  },
  cardMobileHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1.5),
  },
  cardMobileTitle: {
    fontWeight: 'bold',
    fontSize: '14px',
    color: theme.palette.text.primary,
  },
  cardMobileActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  cardMobileLabel: {
    fontWeight: 'bold',
    fontSize: '12px',
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
  },
  cardMobileValue: {
    fontSize: '13px',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  cardMobileDetail: {
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(1),
    borderTop: `1px dashed ${theme.palette.divider}`,
  },
}))
